import { ProjectDataDisplayModelFormGroup } from './../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StateService } from '@/core/services/state.service';
import { AnfrageService, OpenAiService } from '@/api/service-index';
import { ProjectDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { convertJSDateString } from '@/core/utils/date-converter';
import { CheckAnfrageDescriptionQuery } from '@/api/model-index';
import Typewriter from 'typewriter-effect/dist/core';

@Component({
  selector: 'project-data-process-step',
  templateUrl: './project-data-process-step.component.html',
  styleUrls: ['./project-data-process-step.component.scss']
})
export class ProjectDataProcessStepComponent extends AnfrageNavigationFormComponent implements OnInit {

  public projectDataProcessStepForm: ProjectDataDisplayModelFormGroup;
  public projectData: ProjectDataDisplayModel;
  protected canceledRoute: string;

  aiResponse: string = "";
  aiResponseLoading: boolean = false;
  aiResponseFinished: boolean = false;

  public get formGroup(): FormGroup<any> {
    return this.projectDataProcessStepForm;
  }
  
  constructor(protected sectionService: SectionService,
    protected route: ActivatedRoute,
    protected loadingAnimationService: LoadingAnimationService,
    protected router: Router,
    protected anfrageService: AnfrageService,
    protected dialogService: DialogService,
    protected spinnerService: NgxSpinnerService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService,
    protected openAiService: OpenAiService) {

    super(sectionService, router, route, portalContextService);

    this.projectData = this.route.snapshot.data.projectData;
  }

  protected async onVorabCheckClick(): Promise<void> {
    this.aiResponseLoading = true;
    this.aiResponseFinished = false;
    this.aiResponse = "";
  
    let query = new CheckAnfrageDescriptionQuery();
  
    query.anfrageId = this.anfrage.id;
    query.scope = this.portalContextService?.CurrentAnfrage?.objektTyp;
    query.description = this.projectDataProcessStepForm.value?.projektbeschreibung;

    setTimeout(() => {
      console.log("scroll into view", document.getElementById('ai-vorabcheck-loading-div'));
      document.getElementById('ai-vorabcheck-loading-div')?.scrollIntoView();
    }, 50);

    this.openAiService.apiOpenAiCheckAnfrageDescriptionPost(query.AsRequestBody()).toPromise().then(result => {
      this.aiResponse = "";
      this.aiResponseLoading = false;
      this.aiResponseFinished = true;

      setTimeout(() => {
        let element = document.getElementById("ai-vorabcheck-response-div");

        // animate typing effect
        var typewriter = new Typewriter(element, {
            delay: 15,
            autoStart: true,
            loop: false,
            cursor: '',
        });

        // remove Typewriter__cursor div
        let cursor = document.getElementsByClassName('Typewriter__cursor');
        cursor[0].remove();

        typewriter
            .typeString(result?.content)
            .start();

        document.getElementById('ai-vorabcheck-response-div')?.scrollIntoView();
    }, 1);

    }).catch(() => {
      this.aiResponseLoading = false;
    });
  }

  ngOnInit(): void {
    this.projectDataProcessStepForm = ProjectDataDisplayModelFormGroup.Instance;
    
    super.ngOnInit();

    this.projectDataProcessStepForm.patchValue(this.projectData);

    if (this.projectData.projektStart)
      this.projectDataProcessStepForm.ProjektStart.setValue(new Date(this.projectData.projektStart))

    if (this.projectData.projektEnd)
      this.projectDataProcessStepForm.ProjektEnd.setValue(new Date(this.projectData.projektEnd))

    if (this.stateService.IsEndvalidationEnabled)
      this.projectDataProcessStepForm.updateValueAndValidity();
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    let projectData: ProjectDataDisplayModel = this.projectDataProcessStepForm.value;

    if (this.anfrage.projectData && projectData && shouldSave && this.projectDataProcessStepForm.dirty) {
      projectData.projektStart = convertJSDateString(projectData.projektStart);
      projectData.projektEnd = convertJSDateString(projectData.projektEnd);

      delete this.portalContextService.CurrentAnfrage.projectData;
      this.projectDataProcessStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      let subscription = this.anfrageService.apiAnfrageAnfrageIdProjectDataPatch({ anfrageId: this.anfrage.id, body: projectData })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })

          if (this.portalContextService.CurrentAnfrage) {
            this.portalContextService.CurrentAnfrage.projectData = projectData;
            this.portalContextService.CurrentAnfrage.name = projectData.title;
          }
            

          var projekt = this.portalContextService.Anfragen?.find(a => a.id == this.anfrage.id);
          if (projekt && this.anfrage.projectData?.title)
            projekt.name = this.anfrage.projectData.title;

          this.projectDataProcessStepForm.markAsPristine();
        });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.projectDataProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }
}
